import { CreateElement } from "../MyHelpers";
import { ImageResource } from "../ResourceManager/ImageResource";
import { Resourceful } from "../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../ResourceManager/ResourceManager";
import { Translator } from "../Translator";
import { ITranslatedCanvasParams } from "./TranslatedCanvasSprite";

export interface ITranslatedImageParams {
    path: string,
    resid: ResourceIdentifier,
    translator : Translator,
    nameResourceImg: string,
}

export class TranslatedImage implements Resourceful{
    protected viewImg:HTMLElement;
    protected pathImg:string;
    protected languajesImage: Map<string, ImageResource> = new Map<string, ImageResource>();
    protected translator : Translator;
    protected resid : ResourceIdentifier;
    protected nameResourceImg : string;

    constructor( params: ITranslatedImageParams ){
        this.translator = params.translator;
        this.pathImg = params.path;
        this.resid = params.resid;
        this.nameResourceImg = params.nameResourceImg;
    }

    public PrepareResources(resourceManager:IWriteOnlyResourceManager){
        for (let lang of this.translator.availableLanguages) {
            resourceManager.Add(new ImageResource(this.pathImg+"_"+lang.localityShort+".png", this.resid.ScopedResourceName()+ this.nameResourceImg+"-"+lang.localityShort));
        }
    }
    public ResourcesLoaded (resourceManager: IReadOnlyResourceManager){

        for (let lang of this.translator.availableLanguages) {
            let sprite =  resourceManager.Get<ImageResource>(this.resid.ScopedResourceName()+ this.nameResourceImg+"-"+lang.localityShort);
            this.languajesImage.set(lang.localityShort, sprite);
        }
        this.viewImg = CreateElement("div", {
            classes: ["translatorImg", this.resid.Scope()],
            style: {
                position: "relative",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                flexShrink: "0",
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat : "no-repeat",
            }
        });
        this.viewImg.style.backgroundImage = this.languajesImage.get(this.translator.t.localityShort).CssBackground();
        this.translator.SetOnLanguageChangedCallback(() => {
            let currentLanguje = this.translator.t.localityShort;
            this.viewImg.style.backgroundImage= this.languajesImage.get(currentLanguje).CssBackground();
        });
    }

    public View():HTMLElement{
        return this.viewImg;
    }
}